module.exports = __webpack_public_path__ + "img/sl.43d234f7.png";